import styled from 'styled-components';
import { FONTSIZE, sizes, theme, breakpoints } from '../../theme';
// @ts-ignore
import WarningIcon from 'assets/icons/alert-icons/alert-warning-red-icon.svg';
import { CardBase } from 'components/Elements';

export const formTheme = {
    formCardWidth: '700px',
    smallFormCardWidth: '580px',
};

export const FormCard = styled.form`
    ${CardBase}

    display: flex;
    flex-direction: column;
    gap: ${sizes.spacingMd};
    width: ${formTheme.formCardWidth};

    @media (max-width: ${breakpoints.md}) {
        width: 100%;
    }
`;

export const FormFieldContainer = styled.div`
    padding-bottom: ${sizes.spacingSm};
`;

export const FormLabel = styled.label`
    height: ${sizes.spacingRg};
    font-size: ${FONTSIZE.BodyRegular};
    color: ${theme.textColour};
    font-weight: 600;
`;

export const ErrorMessage = styled.p<{ $bold?: boolean }>`
    color: ${theme.errorColour};
    margin: ${sizes.spacingSm} 0;
    font-size: ${FONTSIZE.BodySmall};
    font-weight: ${({ $bold }) => ($bold ? 'bold' : 'inherit')};
`;

// text

export const FormTextInput = styled.input<{ $error?: boolean; width: string }>`
    width: ${({ width }) => width};
    height: 48px;
    display: block;
    font-size: ${FONTSIZE.BodyRegular};
    border-radius: ${sizes.borderRadiusMd};
    border-style: solid;
    border-width: 1px;
    border-color: ${({ $error }) => ($error ? theme.errorColour : theme.inputBorderColour)};
    background: ${({ $error }) =>
        $error ? `url(${WarningIcon}) no-repeat calc(100% - 10px) ${theme.inputBackgroundError}` : null};
    font-family: ${theme.fontFamilyMain};
    margin-top: 7px;
    text-indent: 0;
    padding: 16px;
    &:focus {
        outline: none;
        border-style: solid;
        border-width: 3px;
        border-color: ${({ $error }) => ($error ? theme.errorColour : theme.inputActiveColour)};
    }
`;

export const FormTextAreaInput = styled.textarea<{ $error?: boolean }>`
    width: 100%;
    text-indent: 0;
    padding: 16px;
    min-width: 100%;
    max-width: 100%;
    font-size: ${FONTSIZE.BodyRegular};
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    border-color: ${({ $error }) => ($error ? theme.errorColour : theme.inputBorderColour)};
    background: ${({ $error }) => ($error ? `url(${WarningIcon}) no-repeat calc(100% - 10px)` : null)};
    font-family: ${theme.fontFamilyMain};
    margin-top: 7px;
    &:focus {
        outline: none;
        border-style: solid;
        border-width: 3px;
        border-color: ${({ $error }) => ($error ? theme.errorColour : theme.inputActiveColour)};
    }
`;
